import {lazy} from 'react';

const loadModule = () => import('./routes/ModuleRoutes');
export const AuditsModule = lazy(loadModule);

export default AuditsModule;
